import React from 'react';
import { CheckCircle } from '@mui/icons-material';

interface DecisionOutcomeCardProps {
    prompt: string;
    chosenText: string;
    feedback: string;
}

const DecisionOutcomeCard: React.FC<DecisionOutcomeCardProps> = ({ prompt, chosenText, feedback }) => {
    return (
        <div className="bg-slate-800 border border-slate-700 rounded-xl p-4 animate-fade-in">
            <div className="flex items-start gap-3">
                <div className="p-1.5 bg-green-500/20 rounded-lg shrink-0 mt-0.5">
                    <CheckCircle className="text-green-400" fontSize="small" />
                </div>
                <div className="min-w-0">
                    <p className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1">Decision Made</p>
                    <p className="text-slate-400 text-xs mb-1">{prompt}</p>
                    <p className="text-white text-sm font-medium mb-2">{chosenText}</p>
                    {feedback && (
                        <p className="text-slate-400 text-xs italic border-l-2 border-blue-500/50 pl-3">{feedback}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DecisionOutcomeCard;
